import { useRef, useState } from 'react';

const useUndoableState = <T>(initialValue: T) => {
	const [state, setState] = useState<T>(initialValue);
	const history = useRef<T>(initialValue);

	const setNewState = (newState: T) => {
		setState(newState);
	};

	const undo = () => {
		setState(history.current);
	};

	const save = () => {
		history.current = state;
	};

	return [state, setNewState, undo, save] as const;
};

export default useUndoableState;
